import { Controller } from "@hotwired/stimulus";
import { enter, leave } from "el-transition";

// Connects to data-controller="drawer"
export default class extends Controller {
  static targets = ["container", "backdrop", "drawer", "content"];

  connect() {
    this.contentTarget.addEventListener(
      "turbo:frame-load",
      this.handleFrameLoad.bind(this)
    );

    this.onEscape = this.onEscape.bind(this);
    document.addEventListener("keydown", this.onEscape);
  }

  disconnect() {
    this.contentTarget.removeEventListener(
      "turbo:frame-load",
      this.handleFrameLoad.bind(this)
    );

    document.removeEventListener("keydown", this.onEscape);
  }

  close() {
    this.hide();
  }

  show(e) {
    const { src, favourites } = e.params;

    enter(this.drawerTarget);
    enter(this.backdropTarget);

    this.contentTarget.setAttribute("src", src);

    if (favourites) {
      this.favouritesEnabled = true;
    }

    this.isOpen = true;
  }

  hide() {
    leave(this.drawerTarget);
    leave(this.backdropTarget);
    this.isOpen = false;

    setTimeout(() => this.clearTurboFrameContent(), 500); // wait for the transition to finish before removing the element
  }

  handleFrameLoad() {
    // Reset favourites for drawers where favourites can be added for Tippy
    if (this.favouritesEnabled) {
      window.resetFavourites();
    }
  }

  clearTurboFrameContent() {
    this.contentTarget.removeAttribute("src");
    this.contentTarget.innerHTML = "";
  }

  onEscape(e) {
    if (this.isOpen && e.key === "Escape") {
      this.close();
    }
  }
}
